export default __webpack_public_path__ + "static/media/natour.d300d69c.jpg";